<script setup lang="ts">
import { useAppSearch } from "../business/useAppSearch";
import SuggestionBlock from "./SuggestionBlock.vue";
import { useSearchHistoryStore } from "~/features/store/search-history";
import { ESearchSuggestionBlockType, type TSearchSuggestionBlock } from "../models/TSearchSuggestions";

const { suggestions } = useAppSearch();
const { searchHistory } = useSearchHistoryStore();

const searchedBlock = computed<TSearchSuggestionBlock | null>(() => {
  if (!searchHistory.value.length) return null;
  
  return {
    items: searchHistory.value,
    blockType: ESearchSuggestionBlockType.searched,
  };
});

const blocks = computed<TSearchSuggestionBlock[]>(() => {
  return [searchedBlock.value, ...suggestions.value.blocks].filter(block => block !== null);
});
</script>

<template>
  <div class="search-results">
    <SuggestionBlock 
      v-for="block in blocks" 
      :key="block.blockType" 
      :block="block" 
      class="search-results__block" 
    />
  </div>
</template>

<style scoped lang="stylus">
.search-results
  display flex
  flex-direction column
  gap 8px

  &__block
    &:first-child
      @media (max-width: $pre-laptop)
        padding-top 16px
</style>